import { suppliesPromotionIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deleteSuppliesPromotion = unaryRpc({
  name: "deleteSuppliesPromotion" as const,
  input: z.object({ id: suppliesPromotionIdFormat.schema }),
  output: z.object({}),
});
